import { Create, useForm } from '@refinedev/antd';
import { Form, Input } from 'antd';
import { ICertifiers } from 'interfaces/certifiers';

export const CertifierCreate = () => {
  const { formProps, saveButtonProps } = useForm<ICertifiers>({
    successNotification: () => ({
      type: 'success',
      description: 'Sucesso!',
      message: 'Instituição certificadora criada com sucesso!'
    }),
    errorNotification: () => ({
      type: 'error',
      description: 'Error!',
      message: 'Não foi possível criar a instituição certificadora!'
    })
  });
  return (
    <Create
      saveButtonProps={saveButtonProps}
      title="Criar instituição certificadora"
    >
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Nome da instituição"
          name="name"
          rules={[
            {
              required: true,
              message: 'Nome obrigatório'
            }
          ]}
        >
          <Input style={{ maxWidth: 600 }} />
        </Form.Item>
        <Form.Item
          label="Código"
          name="code"
          rules={[
            {
              required: true,
              message: 'Código obrigatório'
            }
          ]}
        >
          <Input style={{ maxWidth: 200 }} />
        </Form.Item>

        <Form.Item
          label="Credenciamento"
          name="accreditation"
          rules={[{ required: true, message: 'Campo obrigatório' }]}
        >
          <Input.TextArea rows={4} style={{ maxWidth: 600 }} />
        </Form.Item>

        <Form.Item label="Recredenciamento" name="reaccreditation">
          <Input.TextArea rows={4} style={{ maxWidth: 600 }} />
        </Form.Item>
      </Form>
    </Create>
  );
};
